import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { plural } from './utils'

interface ResetToCareforceDialogProps {
  name: string
  instanceCount: number
  variantCount: number
  isResetting: boolean
  onConfirm: () => void
}

export function resetToCareforceDescription(
  name: string,
  instanceCount: number,
  variantCount: number
): string {
  if (instanceCount === 0) {
    return `This deletes your wording for “${name}”. New scripts follow Careforce's text.`
  }
  const withVariant =
    variantCount > 0
      ? `, including ${plural(variantCount, 'duty')} with a variant`
      : ''
  return `This deletes your wording for “${name}”. Careforce's text is back for ${plural(instanceCount, 'duty')} on the next call${withVariant}.`
}

/**
 * The copy's own reset. Sits where "Reset to primary" sits on a variant
 * sheet; the two never appear together, because a variant sheet on a copy
 * resets the variant, not the copy.
 */
export function ResetToCareforceDialog({
  name,
  instanceCount,
  variantCount,
  isResetting,
  onConfirm,
}: ResetToCareforceDialogProps) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="mr-auto"
          disabled={isResetting}>
          Reset to Careforce
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent size="sm">
        <AlertDialogHeader>
          <AlertDialogTitle>Reset to Careforce?</AlertDialogTitle>
          <AlertDialogDescription>
            {resetToCareforceDescription(name, instanceCount, variantCount)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isResetting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            disabled={isResetting}
            onClick={(event) => {
              // Radix closes on click; keep it up (disabled) while the DELETE
              // runs so a failure has a retry seat.
              event.preventDefault()
              onConfirm()
            }}>
            {isResetting ? 'Resetting…' : 'Reset to Careforce'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
